<template>
  <div class="mod-config">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item>
        <el-input v-model="dataForm.transNo" placeholder="支付交易流水号" clearable>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="dataForm.orderId" placeholder="商户交易流水号" clearable>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="dataForm.applyId" placeholder="借款订单ID" clearable>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-select v-model="dataForm.payChannelId" placeholder="支付渠道" clearable>
          <el-option 
            v-for="item in payChannelOptions" 
            :key="item.value" 
            :label="item.label" 
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="dataForm.status" placeholder="交易状态" clearable>
          <el-option 
            v-for="item in statusOptions" 
            :key="item.value" 
            :label="item.label" 
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
            <el-date-picker
                    v-model="date"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="交易创建日期"
                    end-placeholder="交易结束日期"
                     :default-time="['00:00:00','23:59:59']"
                     value-format="yyyy-MM-dd HH:mm:ss"
                    @change="getTimes"
                    unlink-panels>
            </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button @click="getDataList()">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="dataList"
      border
      v-loading="dataListLoading"
      style="width: 100%;">
      <el-table-column
        type="selection"
        header-align="center"
        align="center"
        width="50">
      </el-table-column>
      <el-table-column
        prop="id"
        header-align="center"
        align="center"
        label="主键编号">
      </el-table-column>
      <el-table-column
        prop="accountingDate"
        header-align="center"
        align="center"
        label="账务日期">
      </el-table-column>
      <el-table-column
        prop="finishTime"
        header-align="center"
        align="center"
        label="支付完成时间">
      </el-table-column>
      <el-table-column
        prop="oidPartner"
        header-align="center"
        align="center"
        label="商户编号">
      </el-table-column>
      <el-table-column
        prop="retCode"
        header-align="center"
        align="center"
        label="请求结果代码">
      </el-table-column>
      <el-table-column
        prop="retMsg"
        header-align="center"
        align="center"
        label="请求结果描述">
      </el-table-column>
      <el-table-column
        prop="totalAmount"
        header-align="center"
        align="center"
        label="订单总金额">
      </el-table-column>
      <el-table-column
        prop="txnSeqno"
        header-align="center"
        align="center"
        label="商户交易流水号">
      </el-table-column>
      <el-table-column
        prop="userId"
        header-align="center"
        align="center"
        label="付款方标识">
      </el-table-column>
      <el-table-column
        prop="accpTxno"
        header-align="center"
        align="center"
        label="支付交易流水号">
      </el-table-column>
      <el-table-column
        prop="applyId"
        header-align="center"
        align="center"
        label="借款订单ID">
      </el-table-column>
      <el-table-column header-align="center" align="center" label="交易状态">
        <template slot-scope="scope">
          {{ getLabelByValue(statusOptions, scope.row.txnStatus) }}
        </template>
      </el-table-column>
      <el-table-column prop="notifyResponse" label="异步通知参数" 
      header-align="center" align="center" 
      width="150" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="requestParameters" label="交易请求参数" 
      header-align="center" align="center" 
      width="150" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="response" label="交易响应参数" 
      header-align="center" align="center" 
      width="150" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="remark"
        header-align="center"
        align="center"
        label="备注">
      </el-table-column>
      <el-table-column header-align="center" align="center" label="支付渠道">
        <template slot-scope="scope">
          {{ getLabelByValue(payChannelOptions, scope.row.payChannelId) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="createDate"
        header-align="center"
        align="center"
        label="创建时间">
      </el-table-column>
    </el-table>
    <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
  </div>
</template>
<script>
  import mixinViewModule from "@/mixins/view-module";
  export default {
    mixins: [mixinViewModule],
    data () {
      return {
        // 支付状态选项数组
        statusOptions: [
          { label: '交易中', value: 'TRADE_BEING_PROCESSED' },
          { label: '交易成功', value: 'TRADE_SUCCESS' },
          { label: '交易失败', value: 'TRADE_FAILURE' },
          { label: '交易取消', value: 'TRADE_CANCEL' }
        ],
        // 支付渠道
        payChannelOptions: [
          { label: '连连支付', value: 0 },
          { label: '统统付', value: 1 }
        ],
        dataForm: {
          id: null,
          transNo: '',
          orderId: '',
          applyId: '',
          payChannelId:'',
          status: '',
          createStart: '',
          createEnd: '',
        },
        date: null,
        mixinViewModuleOptions: {
        getDataListURL: "/api/trans-record/page",
        getDataListIsPage: true
      },
      }
    },
    components: {
     
    },
    activated () {
      this.getDataList()
    },
  
    methods: {
      getTimes() {
        if (this.date != null) {
          this.dataForm.createStart = this.date[0]
          this.dataForm.createEnd = this.date[1]
          console.log(33,this.dataForm);
        } else{
          delete this.dataForm.createStart
          delete this.dataForm.createEnd
        }
     },
     getLabelByValue(options, value) {
        const item = options.find(option => option.value === value);
        return item ? item.label : value;
     }
    }
  }
</script>
